import { type CharacterState } from './character';
import { type Npc } from './npc';

export const ARENA_HALF_GAP = 1.3;

export interface EncounterScene {
  opponentNpcIndex: number;
  arenaX: number;
  arenaZ: number;
  playerSavedX: number;
  playerSavedZ: number;
  playerSavedYaw: number;
  opponentSavedX: number;
  opponentSavedZ: number;
  opponentSavedYaw: number;
}

// Snapshot positions and warp combatants to opposite sides of an arena
// centered between them. Player faces +X, opponent faces -X.
export const startEncounter = (
  player: CharacterState,
  npcs: Npc[],
  npcIdx: number,
): EncounterScene => {
  const opponent = npcs[npcIdx]!;
  const arenaX = (player.x + opponent.x) * 0.5;
  const arenaZ = (player.z + opponent.z) * 0.5;
  const scene: EncounterScene = {
    opponentNpcIndex: npcIdx,
    arenaX,
    arenaZ,
    playerSavedX: player.x,
    playerSavedZ: player.z,
    playerSavedYaw: player.yaw,
    opponentSavedX: opponent.x,
    opponentSavedZ: opponent.z,
    opponentSavedYaw: opponent.yaw,
  };
  player.x = arenaX - ARENA_HALF_GAP;
  player.z = arenaZ;
  player.yaw = Math.PI / 2;
  opponent.x = arenaX + ARENA_HALF_GAP;
  opponent.z = arenaZ;
  opponent.yaw = -Math.PI / 2;
  return scene;
};

export const endEncounter = (
  scene: EncounterScene,
  player: CharacterState,
  npcs: Npc[],
): void => {
  player.x = scene.playerSavedX;
  player.z = scene.playerSavedZ;
  player.yaw = scene.playerSavedYaw;
  const opponent = npcs[scene.opponentNpcIndex]!;
  opponent.x = scene.opponentSavedX;
  opponent.z = scene.opponentSavedZ;
  opponent.yaw = scene.opponentSavedYaw;
  opponent.pauseRemaining = 1; // give them a beat before they wander again
};
